import { render, staticRenderFns } from "./AutoMapping.vue?vue&type=template&id=661a7a12&scoped=true&"
import script from "./AutoMapping.vue?vue&type=script&lang=ts&"
export * from "./AutoMapping.vue?vue&type=script&lang=ts&"
import style0 from "./AutoMapping.vue?vue&type=style&index=0&id=661a7a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a7a12",
  null
  
)

export default component.exports